#import "./mediaSliderDataFragment.gql"
#import "./documentDownloadDataFragment.gql"

query getCatalogSeriesDataById(
  $baseSiteId: BaseSiteId!
  $apiLang: String!
  $seriesId: String!
  $maxHeadings: Int
  $includeLogisticAttributes: Boolean = false
) {
  getCatalogSeriesDataById(baseSiteId: $baseSiteId, apiLang: $apiLang, seriesId: $seriesId) {
    RootCategory
    Number
    Media {
      ...mediaSliderData
    }
    AssemblyMedia {
      Name
      media: filteredMedia(outputType: "PR") {
        Url
        label: getTextListValue(first: true)
        TextList {
          Key
          Value
        }
      }
    }
    Documents {
      AdditionalDocuments {
        ...documentDownloadData
      }
      Approvals {
        DocumentId
        Url
        Name
        Format
        FileSize
        ValidFrom
        ValidTo
        Description
        nr: getAttributeListValue(key: "ZULANR")
        ChildDocumentIds
        ParentDocumentId
        TextList {
          Key
          Value
        }
        Group {
          Value
          GroupRank
          DocumentRank
        }
      }
    }
    TextList {
      Key
      Value
    }
    description: getTextListValue(key: "DOKBSTMARKDESCR")
    familyLineDrawing
    seriesAttributes: seriesAttributes(
      max: $maxHeadings
      includeLogisticAttributes: $includeLogisticAttributes
    ) {
      AttributeKey
      AttributeName
      TechnicalName
      Unit
    }
    Slug
    CategoryDisplayNamePath
    SystemItem
    DefiningAttributes {
      FilterId
      FilterName
      SortOrder
      Unit
      Attributes {
        AttributeKey
        AttributeName
        Value
      }
    }
    FilterAttributes {
      FilterId
      FilterName
      SortOrder
      Unit
      Attributes {
        AttributeKey
        AttributeName
        Value
      }
    }
  }
}
